var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "close_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m106.45,311.55c0,3.21,1.25,6.22,3.51,8.48,2.27,2.27,5.28,3.52,8.49,3.52s6.22-1.25,8.49-3.52l88.06-88.06,88.06,88.06c2.27,2.27,5.28,3.52,8.49,3.52s6.22-1.25,8.48-3.51c2.27-2.27,3.52-5.28,3.52-8.49s-1.25-6.22-3.52-8.48l-88.06-88.06,88.06-88.06c2.27-2.27,3.52-5.28,3.52-8.49s-1.25-6.22-3.51-8.48c-2.27-2.27-5.28-3.52-8.49-3.52s-6.22,1.25-8.48,3.52l-88.06,88.06-88.06-88.06c-2.27-2.27-5.28-3.52-8.49-3.52s-6.22,1.25-8.49,3.51-3.52,5.28-3.52,8.49,1.25,6.22,3.51,8.48l88.06,88.06-88.06,88.06c-2.27,2.27-3.52,5.28-3.52,8.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b36fa1d28736fb3ce82e9808e8165eda.svg";
export { ForwardRef as ReactComponent };